var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "menu-main" },
    [
      _c(
        "el-menu",
        {
          staticClass: "el-menu-vertical-demo",
          attrs: {
            "background-color": "#f8fbff",
            "text-color": "#5f6f8f",
            "active-text-color": "#2f436d",
            "unique-opened": true,
            "default-active": _vm.activeMenuIndex,
            "default-openeds": _vm.openSubMenu,
          },
          on: { select: _vm.handleMenuSelect },
        },
        [
          _c(
            "router-link",
            { staticClass: "router-link", attrs: { to: "/" } },
            [
              _c(
                "el-menu-item",
                { staticClass: "menu-logo-item", attrs: { index: "1" } },
                [
                  _c("i", { staticClass: "el-icon-s-home menu-logo-icon" }),
                  _c(
                    "span",
                    {
                      staticClass: "onekids-title",
                      attrs: { slot: "title" },
                      slot: "title",
                    },
                    [_vm._v("ONEKIDS ADMIN")]
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            [
              _vm.getAppTypeUserLogin === _vm.appType.SUPPER_SYSTEM
                ? _c(
                    "el-submenu",
                    {
                      staticClass: "menu-group-staff",
                      attrs: { index: "2" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("i", { staticClass: "el-icon-notebook-2" }),
                                _c("span", [_vm._v("Quản lý nhân viên")]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        1072619541
                      ),
                    },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "router-link",
                          attrs: { to: "/master/admin/list" },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: { index: "2-1" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "master-admin-list"
                                  )
                                },
                              },
                            },
                            [_vm._v("Danh sách nhân viên\n            ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "router-link",
                        {
                          staticClass: "router-link",
                          attrs: { to: "/master/admin/school" },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: { index: "2-2" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "master-admin-school"
                                  )
                                },
                              },
                            },
                            [_vm._v("Phân quản lý trường\n            ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.getAppTypeUserLogin === _vm.appType.SUPPER_SYSTEM ||
              _vm.getAppTypeUserLogin === _vm.appType.SYSTEM
                ? _c(
                    "el-submenu",
                    {
                      staticClass: "menu-group-agent",
                      attrs: { index: "3" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("i", { staticClass: "el-icon-notebook-2" }),
                                _c("span", [_vm._v("Quản lý đại lý")]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        554113292
                      ),
                    },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "router-link",
                          attrs: { to: "/master/agent/list" },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: { index: "3-1" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "master-agent-list"
                                  )
                                },
                              },
                            },
                            [_vm._v("Danh sách đại lý\n            ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "router-link",
                        {
                          staticClass: "router-link",
                          attrs: { to: "/master/agent/account" },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: { index: "3-2" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "master-agent-account"
                                  )
                                },
                              },
                            },
                            [_vm._v("Tài khoản đại lý\n            ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-submenu",
                {
                  staticClass: "menu-group-school",
                  attrs: { index: "4" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("i", { staticClass: "el-icon-reading" }),
                          _c("span", [_vm._v("Quản lý trường")]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/master/school-agent/list" },
                    },
                    [
                      _c(
                        "el-menu-item",
                        {
                          attrs: { index: "4-1" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "master-school-agent-list"
                              )
                            },
                          },
                        },
                        [_vm._v("Danh sách trường\n            ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/master/school-agent/account-school" },
                    },
                    [
                      _c(
                        "el-menu-item",
                        {
                          attrs: { index: "4-2" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "master-school-agent-account-school"
                              )
                            },
                          },
                        },
                        [_vm._v("Tài khoản nhà trường\n            ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/master/school-agent/employee-in-school" },
                    },
                    [
                      _c(
                        "el-menu-item",
                        {
                          attrs: { index: "4-3" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "master-school-agent-employee-in-school"
                              )
                            },
                          },
                        },
                        [_vm._v("Danh sách nhân sự\n            ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/master/school-agent/student-in-school" },
                    },
                    [
                      _c(
                        "el-menu-item",
                        {
                          attrs: { index: "4-4" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "master-school-agent-student-in-school"
                              )
                            },
                          },
                        },
                        [_vm._v("Danh sách học sinh\n            ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.getAppTypeUserLogin === _vm.appType.SUPPER_SYSTEM ||
              _vm.getAppTypeUserLogin === _vm.appType.SYSTEM
                ? _c(
                    "el-submenu",
                    {
                      staticClass: "menu-group-brand",
                      attrs: { index: "5" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("i", { staticClass: "el-icon-user" }),
                                _c("span", [_vm._v("Quản lý BrandName")]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        1911735791
                      ),
                    },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "router-link",
                          attrs: { to: "/brandname/brand" },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: { index: "5-1" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "brandname-brand"
                                  )
                                },
                              },
                            },
                            [_vm._v("Cấu hình kết nối\n            ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "router-link",
                        {
                          staticClass: "router-link",
                          attrs: { to: "/brandname/agent" },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: { index: "5-2" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "brandname-agent"
                                  )
                                },
                              },
                            },
                            [_vm._v("Thiết lập Brand đại lý\n            ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "router-link",
                        {
                          staticClass: "router-link",
                          attrs: { to: "/brandname/school-brand" },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: { index: "5-3" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "brandname-school-brand"
                                  )
                                },
                              },
                            },
                            [_vm._v("Thiết lập Brand Trường\n            ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.getAppTypeUserLogin === _vm.appType.SUPPER_SYSTEM ||
              _vm.getAppTypeUserLogin === _vm.appType.SYSTEM
                ? _c(
                    "el-submenu",
                    {
                      staticClass: "menu-group-notify",
                      attrs: { index: "6" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("i", { staticClass: "el-icon-user-solid" }),
                                _c("span", [_vm._v("Quản lý thông báo")]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        1826730542
                      ),
                    },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "router-link",
                          attrs: { to: "/master/notify/news-onekids" },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: { index: "6-1" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "master-notify-news-onekids"
                                  )
                                },
                              },
                            },
                            [_vm._v("Tin tức Onekids\n            ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "router-link",
                        {
                          staticClass: "router-link",
                          attrs: { to: "/master/notify/notify-onekids" },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: { index: "6-2" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "master-notify-notify-onekids"
                                  )
                                },
                              },
                            },
                            [_vm._v("Thông báo Onekids\n            ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "router-link",
                        {
                          staticClass: "router-link",
                          attrs: { to: "/master/notify/history-sms" },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: { index: "6-3" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "master-notify-history-sms"
                                  )
                                },
                              },
                            },
                            [_vm._v("Lịch sử nhắn SMS\n            ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "router-link",
                        {
                          staticClass: "router-link",
                          attrs: { to: "/master/notify/feedback-onekids" },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: { index: "6-4" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "master-notify-feedback-onekids"
                                  )
                                },
                              },
                            },
                            [_vm._v("Góp ý Onekids\n            ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.getAppTypeUserLogin === _vm.appType.SUPPER_SYSTEM ||
              _vm.getAppTypeUserLogin === _vm.appType.SYSTEM
                ? _c(
                    "el-submenu",
                    {
                      staticClass: "menu-group-account",
                      attrs: { index: "7" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("i", { staticClass: "el-icon-s-custom" }),
                                _c("span", [_vm._v("Quản lý tài khoản")]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        2396302835
                      ),
                    },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "router-link",
                          attrs: { to: "/master/user/account" },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: { index: "7-1" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "master-user-account"
                                  )
                                },
                              },
                            },
                            [_vm._v("Tài khoản người dùng\n            ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-submenu",
                {
                  staticClass: "menu-group-config",
                  attrs: { index: "8" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("i", { staticClass: "el-icon-setting" }),
                          _c("span", [_vm._v("Cấu hình hệ thống")]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/master/system-config/attendance-sample" },
                    },
                    [
                      _c(
                        "el-menu-item",
                        {
                          attrs: { index: "8-1" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "master-system-config-attendance-sample"
                              )
                            },
                          },
                        },
                        [_vm._v("Mẫu điểm danh, lời chúc\n            ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/master/system-config/evaluate-sample" },
                    },
                    [
                      _c(
                        "el-menu-item",
                        {
                          attrs: { index: "8-2" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "master-system-config-evaluate-sample"
                              )
                            },
                          },
                        },
                        [_vm._v("Mẫu nhận xét\n            ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/master/system-config/school" },
                    },
                    [
                      _c(
                        "el-menu-item",
                        {
                          attrs: { index: "8-3" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "master-system-config-school"
                              )
                            },
                          },
                        },
                        [_vm._v("Cấu hình nhà trường\n            ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/master/system-config/system-setting" },
                    },
                    [
                      _vm.getAppTypeUserLogin === _vm.appType.SUPPER_SYSTEM
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "8-4" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "master-system-config-system-setting"
                                  )
                                },
                              },
                            },
                            [_vm._v("Thiết lập hệ thống\n            ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/master/system-config/web-system-title" },
                    },
                    [
                      _c(
                        "el-menu-item",
                        {
                          attrs: { index: "8-5" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "master-system-config-web-system-title"
                              )
                            },
                          },
                        },
                        [_vm._v("Thiết lập tiêu đề nội dung\n            ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/master/system-config/api" },
                    },
                    [
                      _vm.getAppTypeUserLogin === _vm.appType.SUPPER_SYSTEM
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "8-6" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "master-system-config-api"
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              Cập nhật quyền\n            "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/master/system-config/support" },
                    },
                    [
                      _c(
                        "el-menu-item",
                        {
                          attrs: { index: "8-7" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "master-system-config-support"
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n              Thiết lập hỗ trợ\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/master/system-config/template" },
                    },
                    [
                      _c(
                        "el-menu-item",
                        {
                          attrs: { index: "8-8" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "master-system-config-template"
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n              Thiết lập giao diện\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/master/system-config/ticket" },
                    },
                    [
                      _c(
                        "el-menu-item",
                        {
                          attrs: { index: "8-9" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "master-system-config-ticket"
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n              Thiết lập phiếu bé ngoan\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/master/system-config/survey-form" },
                    },
                    [
                      _c(
                        "el-menu-item",
                        {
                          attrs: { index: "8-10" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "master-system-config-survey-form"
                              )
                            },
                          },
                        },
                        [_vm._v("Thiết lập phiếu khảo sát\n            ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/master/system-config/orther" },
                    },
                    [
                      _c(
                        "el-menu-item",
                        {
                          attrs: { index: "8-11" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "master-system-config-orther"
                              )
                            },
                          },
                        },
                        [_vm._v("Thiết lập khác\n            ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/package-student/packages" },
                    },
                    [
                      _c(
                        "el-menu-item",
                        {
                          attrs: { index: "8-12" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "package-student-packages"
                              )
                            },
                          },
                        },
                        [_vm._v("Gói giới hạn học sinh\n            ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-submenu",
                {
                  staticClass: "menu-group-systemdata",
                  attrs: { index: "9" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("i", { staticClass: "el-icon-s-shop" }),
                          _c("span", [_vm._v("Dữ liệu hệ thống")]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/master/other/create-data-system" },
                    },
                    [
                      _c(
                        "el-menu-item",
                        {
                          attrs: { index: "9-1" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "master-other-create-data-system"
                              )
                            },
                          },
                        },
                        [_vm._v("Tạo dữ liệu chung\n            ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/master/other/manage-request-system" },
                    },
                    [
                      _vm.getAppTypeUserLogin === _vm.appType.SUPPER_SYSTEM
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "9-2" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "master-other-manage-request-system"
                                  )
                                },
                              },
                            },
                            [_vm._v("Quản lý truy cập\n            ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/master/other/manage-data-system" },
                    },
                    [
                      _c(
                        "el-menu-item",
                        {
                          attrs: { index: "9-3" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "master-other-manage-data-system"
                              )
                            },
                          },
                        },
                        [_vm._v("Quản lý dữ liệu\n            ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/master/other/manage-operation-history" },
                    },
                    [
                      _vm.getAppTypeUserLogin === _vm.appType.SUPPER_SYSTEM
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "9-4" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "master-other-manage-operation-history"
                                  )
                                },
                              },
                            },
                            [_vm._v("Lịch sử thao tác\n            ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/master/other/auto-run-configuration" },
                    },
                    [
                      _vm.getAppTypeUserLogin === _vm.appType.SUPPER_SYSTEM
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "9-5" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "master-other-auto-run-configuration"
                                  )
                                },
                              },
                            },
                            [_vm._v("Cấu hình chạy tự động")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/master/other/receive-messages-system" },
                    },
                    [
                      _vm.getAppTypeUserLogin === _vm.appType.SUPPER_SYSTEM
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "9-6" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "master-other-receive-messages-system"
                                  )
                                },
                              },
                            },
                            [_vm._v("Số điện thoại")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/master/other/icon-system" },
                    },
                    [
                      _vm.getAppTypeUserLogin === _vm.appType.SUPPER_SYSTEM
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "9-7" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "master-other-icon-system"
                                  )
                                },
                              },
                            },
                            [_vm._v("Icon hệ thống")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/master/other/onekids-config" },
                    },
                    [
                      _vm.getAppTypeUserLogin === _vm.appType.SUPPER_SYSTEM
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "9-8" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "master-other-onekids-config"
                                  )
                                },
                              },
                            },
                            [_vm._v("Thiết lập hệ thống")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/master/other/login-config" },
                    },
                    [
                      _vm.getAppTypeUserLogin === _vm.appType.SUPPER_SYSTEM
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "9-9" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "master-other-login-config"
                                  )
                                },
                              },
                            },
                            [_vm._v("Cấu hình trang đăng nhập")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-submenu",
                {
                  staticClass: "menu-group-ai",
                  attrs: { index: "10" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("i", { staticClass: "el-icon-s-platform" }),
                          _c("span", [_vm._v("Quản lý nhận diện AI")]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: {
                        to: "/master/system-config/devices-face-recognition",
                      },
                    },
                    [
                      _c(
                        "el-menu-item",
                        {
                          attrs: { index: "10-1" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "master-devices-face-recognition"
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n              Danh sách thiết bị\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: {
                        to: "/master/system-config/card-manager-recognition",
                      },
                    },
                    [
                      _c(
                        "el-menu-item",
                        {
                          attrs: { index: "10-2" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "master-card-manager-recognition"
                              )
                            },
                          },
                        },
                        [_vm._v("\n              Quản lý thẻ\n            ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: {
                        to: "/master/system-config/check-info-recognition",
                      },
                    },
                    [
                      _c(
                        "el-menu-item",
                        {
                          attrs: { index: "10-3" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "master-check-info-recognition"
                              )
                            },
                          },
                        },
                        [_vm._v("\n              Kiểm tra TT AI\n            ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-submenu",
                {
                  staticClass: "menu-group-banking",
                  attrs: { index: "11" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("i", { staticClass: "el-icon-money" }),
                          _c("span", [_vm._v("Thanh toán trực tuyến")]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/master/system-config/bank-connection" },
                    },
                    [
                      _c(
                        "el-menu-item",
                        {
                          attrs: { index: "11-1" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "master-bank-connection"
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n              Danh sách ngân hàng\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: {
                        to: "/master/system-config/brand-name-connection",
                      },
                    },
                    [
                      _c(
                        "el-menu-item",
                        {
                          attrs: { index: "11-2" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "master-brand-name-connection"
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n              Danh sách đại lý cho trường\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: {
                        to: "/master/system-config/linked-school-bank-account",
                      },
                    },
                    [
                      _c(
                        "el-menu-item",
                        {
                          attrs: { index: "11-3" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "master-linked-school-bank-account"
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n              Danh sách ngân hàng liên kết\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: {
                        to: "/master/system-config/student-user-statistics-admin",
                      },
                    },
                    [
                      _c(
                        "el-menu-item",
                        {
                          attrs: { index: "11-4" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "master-student-user-statistics-admin"
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n              Danh sách học sinh sử dụng\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: {
                        to: "/master/system-config/bank-transaction-statistics",
                      },
                    },
                    [
                      _c(
                        "el-menu-item",
                        {
                          attrs: { index: "11-5" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "master-bank-transaction-statistics"
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n              Thống kê lịch sử giao dịch\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: {
                        to: "/master/system-config/transaction-volume-chart",
                      },
                    },
                    [
                      _vm.getAppTypeUserLogin === _vm.appType.SUPPER_SYSTEM
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "11-6" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "master-transaction-volume-chart"
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              Thống kê số lượng giao dịch\n            "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: {
                        to: "/master/system-config/transaction-counter-admin",
                      },
                    },
                    [
                      _vm.getAppTypeUserLogin === _vm.appType.SUPPER_SYSTEM
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "11-7" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "master-transaction-counter-admin"
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              Bộ đếm giao dịch\n            "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: {
                        to: "/master/system-config/merchant/online-payment",
                      },
                    },
                    [
                      _vm.getAppTypeUserLogin === _vm.appType.SUPPER_SYSTEM
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "11-8" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "master-merchant-online-payment"
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              Quản lý Merchant\n            "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: {
                        to: "/master/system-config/webhook/online-payment",
                      },
                    },
                    [
                      _vm.getAppTypeUserLogin === _vm.appType.SUPPER_SYSTEM
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "11-9" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "master-webhook-online-payment"
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              Quản lý Webhook\n            "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.getAppTypeUserLogin === _vm.appType.SUPPER_SYSTEM
                ? _c(
                    "el-submenu",
                    {
                      staticClass: "menu-group-chat",
                      attrs: { index: "12" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("i", {
                                  staticClass: "el-icon-chat-line-square",
                                }),
                                _c("span", [_vm._v("Quản lý App Chat")]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        2565210764
                      ),
                    },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "router-link",
                          attrs: {
                            to: "/master/system-config/emotion-chat-admin",
                          },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: { index: "12-1" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "master-admin-manager-emotions-chat"
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              Emotions tin nhắn\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "router-link",
                        {
                          staticClass: "router-link",
                          attrs: { to: "/master/system-config/tag-chat-admin" },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: { index: "12-2" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "master-admin-manager-tags-chat"
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              Thẻ hệ thống\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }